import { combineReducers } from 'redux'

import errorReducer from '@reducers/error'
import messageReducer from '@reducers/message'
import subscriberReducer from '@reducers/subscriber'
import uiReducer from '@reducers/ui'

const rootReducer = combineReducers({
  error: errorReducer,
  message: messageReducer,
  subscriber: subscriberReducer,
  ui: uiReducer
})

export default rootReducer
